module.exports = __webpack_public_path__ + "1ecbf749b60bd5a3f68e514bfb466406.png";